import React, { useState, useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import { Grid, Box } from '@mui/material';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { GetProductInfoTable, GetProductPaletInfoForOrderInfoTable } from '../../Helpers/OrderInfoHelper'
import FlagstoneTheme from '../../Config/flagstoneTheme';
import OrderDetailInfoTable from '../Order/OrderDetailInfoTable';
import { ScanBarcode } from 'lucide-react';

export function ProductStep(props) {
    const classes = useStyles();

    //Global feedback
    const [displayBoxShadow, setBoxShadow] = useState("");

    useEffect(() => {
        generatePalletFeedback(props.activePalletData);
    }, [props.activePalletData]);

    const generatePalletFeedback = (palletData) => {
        if (palletData !== null && palletData !== undefined) {
            if (palletData.dataMatches) {
                setBoxShadow(FlagstoneTheme.boxShadow.success);

            } else if (palletData.productMissing || (props.activePalletData.ProductModel === null || props.activePalletData.ProductModel.EanCode === "")) {
                setBoxShadow(FlagstoneTheme.boxShadow.warning);

            } else if (!palletData.dataMatches) {
                setBoxShadow(FlagstoneTheme.boxShadow.error);
            }
        }
    }



    return <Box className={classes.orderContainer} sx={{ border: '1px solid darkgrey', borderRadius: '8px', boxShadow: displayBoxShadow }}>
        {/* <Box className={classes.coloredBorder} ></Box> */}
        <Box sx={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column' }}>
            <Box sx={{ width: '100%' }}>
                <div className={classes.largeBarcode} >
                    <div className={classes.barcodeIcon}>
                        <ScanBarcode size={48} absoluteStrokeWidth strokeWidth={4} />
                    </div>
                    <span className={classes.barcodeText}>
                        {(props.activePalletData !== null && props.activePalletData !== undefined && props.activePalletData.ProductModel !== null && props.activePalletData.ProductModel.EanCode !== "") ? props.activePalletData.ProductModel.EanCode : "-"}
                    </span>
                </div>
            </Box>
            <Grid sx={{ p: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <OrderDetailInfoTable rows={GetProductInfoTable((props.activePalletData !== null && props.activePalletData !== undefined) ? props.activePalletData.ProductModel : null)}></OrderDetailInfoTable>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <OrderDetailInfoTable rows={GetProductPaletInfoForOrderInfoTable((props.activePalletData !== null && props.activePalletData !== undefined) ? props.activePalletData.ProductModel : null)}></OrderDetailInfoTable>
                    </Grid>
                </Grid>
            </Grid>

        </Box>

    </Box>
}

const useStyles = makeStyles({
    orderContainer: {
        backgroundColor: "white",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        width: "100%"

    },
    orderReference: {
        width: '100%',
    },
    reference: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        marginBottom: "10px"

    },
    orderNumber: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        display: "block",
        marginBottom: "10px"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
    },
    leftHeader: {
        width: "50%",
        float: "left"
    },
    upperOrderInfo: {
        display: 'flex',
        flexDirection: 'row',
    },
    info: {

        color: "#020100",
        display: "block",
    },
    rightHeader: {
        textAlign: "right",
        width: "50%",
        float: "left",
        display: 'flex',
        justifyContent: 'end'
    },
    machineDiv: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
    },
    coloredBorder: {
        float: "left",
        width: "7px",
        height: "180px",
        borderRadius: "6px 0px 0px 6px",
        opacity: "0.28",
    },
    largeBarcode: {
        fontSize: '60px',
        position: 'relative',
        minHeight: "90px",
        textAlign: "center",
        backgroundColor: '#ededed',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        borderRadius: '8px 8px 0 0',
    },
    barcodeIcon: {
        color: 'rgb(96, 96, 96)',
        position: 'absolute',
        left: '10px',
        height: '100%',
        display: 'flex', justifyContent: 'center',
        alignItems: 'center'
    },
    barcodeText: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        marginLeft: '64px',
        alignItems: 'center',

        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        fontSize: '36px',
        color: '#D84949',

        "@media (min-width: 800px)": {
            fontSize: '40px',
        },

        "@media (min-width: 1000px)": {
            fontSize: '48px',
            justifyContent: 'center',
            marginLeft: '0px',
        }
    },

});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        user: state.user,
        general: state.general
    }
}

export default connect(mapStateToProps)(ProductStep)